import { clearAuthFlags, submitLoginRequest } from 'actions/authentication';
import FormAuthTextField from 'components/FormElements/FormAuthTextField';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Required } from 'utils/validators';
import './index.scss';

class LoginForm extends Component {
  componentWillMount() {
    this.props.handleSubmit(() => ({}));
    this.props.clearAuthFlags();
  }

  submitLogin = () => {
    const { email, pwd } = this.props.formValues;
    this.props.submitLoginRequest(email, pwd);
  };

  onEnter = event => {
    if (event.key === 'Enter') {
      this.submitLogin();
    }
  };

  render() {
    return (
      <React.Fragment>
        <h3>Sign in with Fatsoma</h3>

        {this.props.loginError.detail && (
          <div className="auth__error">{this.props.loginError.detail}</div>
        )}
        <form className="auth__form__fields" onKeyDown={this.onEnter}>
          <input type="hidden" value="prayer" />
          <Field
            className="auth__form__field"
            fullWidth
            autoComplete="email"
            name="email"
            type="email"
            margin="normal"
            placeholder="john.smith@me.com"
            component={FormAuthTextField}
            validate={[Required]}
            label="Email Address"
          />

          <Field
            className="auth__form__field"
            fullWidth
            autoComplete="new-password"
            name="pwd"
            type="password"
            margin="normal"
            placeholder="password"
            component={FormAuthTextField}
            validate={[Required]}
            label="Password"
          />

          <FormSubmitButton
            onClick={this.submitLogin}
            className="auth__cta__button"
            loading={this.props.loading}
          >
            Sign In
          </FormSubmitButton>
        </form>

        <div className="auth__line__break" />

        <div className="forgotten__password">
          <div className="forgotten__password__header">
            Forgot your password?
          </div>
          <div className="forgotten__password__content">
            <a
              href="https://www.fatsoma.com/forgot-password"
              rel="noopener noreferrer"
              target="_blank"
            >
              Visit Fatsoma
            </a>{' '}
            to reset your password.
            <br />
            You can then return to this page to sign in.
          </div>
        </div>

        <div className="auth__line__break" />

        <div className="not__registered">
          <div className="not__registered__header">
            Don't have a Fatsoma account?
          </div>
          <div className="not__registered__cta">
            <Link to="./register" className="register__link">
              Register
            </Link>
          </div>
        </div>

        <div className="auth__line__break" />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues('login')(state) || {},
    loading: state.authentication.loading,
    loginError: state.authentication.loginError,
    initialValues: state.authentication.formData['login'],
  };
};

const mapDispatchToProps = dispatch => ({
  submitLoginRequest: (email, pwd) => dispatch(submitLoginRequest(email, pwd)),
  clearAuthFlags: () => dispatch(clearAuthFlags()),
});

LoginForm = reduxForm({
  form: 'login',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(LoginForm);

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Authentication/LoginForm/index.jsx